// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-pVqu5s"};